module.exports = __webpack_public_path__ + "static/monoTinkoff-2e5a2e7ea19e5138da4c89bf9a70c481.jpg";